import React, { useState, useEffect } from "react";
import "./ThankYou.css";
import { useNavigate, useLocation } from "react-router-dom";
import { FaRegCopy } from "react-icons/fa";

export default function ThankYou() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const transactionId = state?.transactionId || "N/A";
  const userName = state?.userName || "User";
  const purchaseResponse = state?.purchaseResponse;

  const [copied, setCopied] = useState(false);

  // Store subscription data in localStorage if available
  useEffect(() => {
    if (purchaseResponse?.data?.subscription) {
      localStorage.setItem('subscriptionData', JSON.stringify(purchaseResponse.data.subscription));
    }
  }, [purchaseResponse]);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(transactionId);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="thankyou-container">
      <div className="thankyou-card">
        
        <div className="check-icon">✓</div>

        <h1>Thank you, {userName}!</h1>
        <p>Your payment was successfully processed.</p>

        <p className="enjoy-text">
          Enjoy unlimited streaming with your premium plan.
        </p>

        <div className="details-box">
          <p><strong>Transaction ID:</strong></p>

          <div className="tran-id-row">
            <p className="tran-id">{transactionId}</p>

            <div className="copy-wrapper">
              {copied && <span className="copied-text">Copied!</span>}
              <FaRegCopy
                className="copy-icon"
                onClick={copyToClipboard}
              />
            </div>
          </div>
        </div>

        <button className="go-home-btn" onClick={() => navigate("/")}>
          Go to Home
        </button>
      </div>
    </div>
  );
}